// Plushie Town Arcade — theme.js
// Mobile nav toggle handled inline in sections/header.liquid.
// Add cart drawer / AJAX cart / filter interactivity here as the build grows.
document.addEventListener('DOMContentLoaded', function () {
  console.log('Plushie Town Arcade theme loaded');
});
